import { DateTime } from "luxon";
import { z } from "zod";
import { isoDateTimeSchema } from "./filters.js";
const automationRunIdSchema = z.uuid().brand();
function asAutomationRunId(id) {
  return automationRunIdSchema.parse(id);
}
const allAutomationRunStatuses = [
  "pending",
  "running",
  "succeeded",
  "failed",
  "canceled"
];
const automationRunStatusSchema = z.enum(allAutomationRunStatuses);
const TERMINAL_AUTOMATION_RUN_STATUSES = /* @__PURE__ */ new Set(["succeeded", "failed", "canceled"]);
const analysisWindowBoundsSchema = z.object({
  start: isoDateTimeSchema.describe(
    "Analyze calls on or after this ISO datetime."
  ),
  end: isoDateTimeSchema.describe("Analyze calls before this ISO datetime.")
}).refine(({ start, end }) => DateTime.fromISO(start) < DateTime.fromISO(end), {
  message: "start must be before end",
  path: ["end"]
});
export {
  TERMINAL_AUTOMATION_RUN_STATUSES,
  allAutomationRunStatuses,
  analysisWindowBoundsSchema,
  asAutomationRunId,
  automationRunIdSchema,
  automationRunStatusSchema
};
//# sourceMappingURL=automationRun.js.map
